import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { User } from '@/modules/user/models/User';
import { EstateTask } from '@/modules/estatetask/models/EstateTask';
import { TeamType } from '@/modules/team/enums/TeamType';
import { TeamUser } from '@/modules/team/models/TeamUser';

export class Team extends BaseEntityModel {
  id?: number;

  name?: string;

  companyId?: number;

  leadUserId?: number;

  type?: string;

  hasActivePlatformProduct?: boolean;

  leadUser?: Relationship<User | null>;

  estateTasks?: Relationship<EstateTask[] | null>;

  users?: Relationship<User[] | null>;

  teamUsers?: Relationship<TeamUser[] | null>;

  constructor(model: Partial<Team> = {}) {
    super(model);

    this.id = model.id;
    this.name = model.name;
    this.companyId = model.companyId;
    this.leadUserId = model.leadUserId;
    this.type = model.type;
    this.hasActivePlatformProduct = model.hasActivePlatformProduct ?? false;

    // @ts-ignore
    this.leadUser = User.mapModelOrNull(model.leadUser);
    // @ts-ignore
    this.estateTasks = EstateTask.mapModelsOrNull(model.estateTasks);
    // @ts-ignore
    this.users = User.mapModelsOrNull(model.users);
  }

  getModelName(): ModelType {
    return ModelType.TEAM;
  }

  get avatarLetters(): string {
    return this.name?.charAt(0) ?? '';
  }

  get isJuniorEstateProfessionalTeam(): boolean {
    return this.type === TeamType.JUNIOR_ESTATE_PROFESSIONAL.key;
  }

  get isAccountantTeam(): boolean {
    return this.type === TeamType.ACCOUNTANT.key;
  }
}
